module.exports = __webpack_public_path__ + "img/6.82899c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/6.jpg
// module id = 210
// module chunks = 1